<template>
    <section class="w-full mt-20 py-16 md:py-28 lg:py-36" id="features">
        <div class="container px-4 md:px-8">
            <div class="flex flex-col items-center justify-center space-y-6 text-center">
                <div class="space-y-3">
                    <h2 class="text-3xl font-bold tracking-tight sm:text-6xl">Our Features</h2>
                    <p class="max-w-[900px] text-gray-500 text-lg md:text-2xl leading-relaxed">
                        Discover how our platform can enhance your social media engagement and help you grow.
                    </p>
                </div>
            </div>
            <div class="mx-auto grid max-w-5xl items-center gap-8 py-16 lg:grid-cols-3">
                <div class="flex flex-col items-center space-y-6 text-center">
                    <div class="w-full flex items-center justify-center bg-transparent overflow-hidden sm:aspect-square">
                        <img 
                          src="../assets/achievement.jpg" 
                          alt="Gamified Experience" 
                          class="object-contain w-full h-auto"
                          width="400"
                          height="400"
                          loading="lazy"
                        />
                    </div>
                    <h3 class="text-2xl font-bold">Gamified Experience</h3>
                    <p class="text-base text-gray-500 leading-relaxed">
                        Turn your social media activity into a game with achievements and leaderboards.
                    </p>
                </div>
                <div class="flex flex-col items-center space-y-6 text-center">
                    <div class="w-full flex items-center justify-center bg-transparent overflow-hidden sm:aspect-square">
                        <img 
                          src="../assets/daily_missions.jpg" 
                          alt="Daily Missions" 
                          class="object-contain w-full h-auto"
                          width="400"
                          height="400"
                          loading="lazy"
                        />
                    </div>
                    <h3 class="text-2xl font-bold">Daily Missions</h3>
                    <p class="text-base text-gray-500 leading-relaxed">
                        Complete daily tasks tailored to your social media accounts for extra motivation.
                    </p>
                </div>
                <div class="flex flex-col items-center space-y-6 text-center">
                    <div class="w-full flex items-center justify-center bg-transparent overflow-hidden sm:aspect-square">
                        <img 
                          src="../assets/leaderboard.jpg" 
                          alt="Community Engagement" 
                          class="object-contain w-full h-auto"
                          width="400"
                          height="400"
                          loading="lazy"
                        />
                    </div>
                    <h3 class="text-2xl font-bold">Community Engagement</h3>
                    <p class="text-base text-gray-500 leading-relaxed">
                        Compete with friends and grow together in a vibrant community.
                    </p>
                </div>
            </div>
        </div>
    </section>
</template>
